<script>
    import { page } from "$app/stores";
    import { store } from "$lib/utilities/store";

    import RenderJson from "$lib/components/RenderJSON/RenderJSON.svelte";

    export let lang;
    export let col;
    export let preview;
    export let settingId;
    export let sections;
    export let questions;
    export let responses;
    export let responseState;
    export let sectionState;
    export let activeTabs;
    export let firstTab;
    export let lastTab;
    export let selectedTab;
    export let selectedTabIndex;
    export let nextTab;
    export let previousTab;
    export let lastQuestion;

    $: showDiags =
        typeof $store?.userProfile?.uid === "string" &&
        $page?.route?.id === "/admin";

    $: responseStateFields = [
        ...new Set([
            ...Object.entries(responseState).flatMap(([_, v]) =>
                Object.keys(v),
            ),
        ]),
    ];

    $: tableFields = ["Label", "Response", ...responseStateFields];
    $: tableRows = questions.map((q) => ({
        Label: q.label?.value,
        Response: responses?.[q.label?.value],
        ...responseStateFields.reduce(
            (a, v) => ({ ...a, [v]: responseState[q.questionId]?.[v] }),
            {},
        ),
    }));
</script>

{#if showDiags}
    <!-- <div class="my-16"> -->
    <div class="shadow-xl collapse collapse-arrow bg-base-300">
        <input type="checkbox" />
        <div class="font-medium collapse-title">Form Diagnostics</div>
        <div class="collapse-content">
            <div class="my-2 sm:my-4">
                <div class="w-full">
                    <div>apply now</div>
                    <div>{lang}</div>
                    <div>{col}</div>
                    <div>{preview}</div>
                    <div>{settingId}</div>
                    <div>activeTabs: {activeTabs}</div>
                    <div>firstTab: {firstTab}</div>
                    <div>lastTab: {lastTab}</div>
                    <div>selectedTab: {selectedTab}</div>
                    <div>selectedTabIndex: {selectedTabIndex}</div>
                    <div>nextTab: {nextTab}</div>
                    <div>previousTab: {previousTab}</div>
                    <h3>Current Last Question</h3>
                    <RenderJson
                        strJson={JSON.stringify({
                            [lastQuestion?.label?.value]: lastQuestion,
                        })}
                    />
                    <div class="flex gap-16">
                        <div>
                            <h3>Sections</h3>
                            {#each sections as section}
                                <RenderJson
                                    strJson={JSON.stringify({
                                        [section.label]: {
                                            section,
                                            sectionState:
                                                sectionState[section.id],
                                        },
                                    })}
                                />
                            {/each}
                        </div>
                        <div>
                            <h3>Selected Questions</h3>
                            {#each questions as question}
                                <RenderJson
                                    strJson={JSON.stringify({
                                        [question.label?.value]: question,
                                    })}
                                />
                            {/each}
                        </div>
                        <div>
                            <h3>Responses</h3>
                            {#each questions as question}
                                <RenderJson
                                    strJson={JSON.stringify({
                                        [question.label?.value]:
                                            responses?.[question.label?.value],
                                    })}
                                />
                            {/each}
                        </div>
                        <div>
                            <h3>Response Valid</h3>
                            {#each questions as question}
                                <RenderJson
                                    strJson={JSON.stringify({
                                        [question.questionId]:
                                            responseState[question.questionId],
                                    })}
                                />
                            {/each}
                        </div>
                    </div>
                    <div>
                        <table class="table table-zebra whitespace-nowrap">
                            <thead>
                                <tr>
                                    {#each tableFields as fld}
                                        <th>
                                            {fld}
                                        </th>
                                    {/each}
                                </tr>
                            </thead>
                            <tbody>
                                {#each tableRows as row}
                                    <tr>
                                        {#each tableFields as fld}
                                            <th>
                                                {row[fld]}
                                            </th>
                                        {/each}
                                    </tr>
                                {/each}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
{/if}
